module.exports = __webpack_public_path__ + "d29570aa253d782450eeca982d2c0437.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Ultra-Bold.ttf
// module id = 1247
// module chunks = 0